"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconUser = function SvgIconUser(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "user icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'User Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.5 44c-.69 0-1.25-.56-1.25-1.25v-5.516a6.257 6.257 0 014.111-5.875C12.335 30.282 17.29 29 24 29c6.71 0 11.665 1.282 14.639 2.359a6.257 6.257 0 014.111 5.875v5.516c0 .69-.56 1.25-1.25 1.25zM24 26.5c-5.514 0-10-4.486-10-10V14c0-5.514 4.486-10 10-10s10 4.486 10 10v2.5c0 5.514-4.486 10-10 10z"
  }));
};

var _default = SvgIconUser;
exports.default = _default;